import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { LoadingScreen } from "./components/loading-screen";
import { MyPagesRoutes } from "./types/routes";
import { useUserContext } from "./hooks/use-user-context";
import { hasPermissionOnSystem } from "./models/permission";
import SalaryRoot from "./pages/salary/salary-root";
import NavRoot from "./layout/nav/nav-root";

// React router doesn't like when you don't have an element in a route. So this is just a placeholder component for the auth redirect root
const AuthRoot = () => {
	return false;
};

const Home = React.lazy(() => import("./pages/home/news-root"));
const Schedule = React.lazy(() => import("./pages/schedule/schedule-root"));
const TimeReport = React.lazy(() => import("./pages/time-report/time-report-root"));
// const Salary = React.lazy(() => import("./pages/salary/salary-root"))
const Messages = React.lazy(() => import("./pages/messages/message-root"));
const MyProfile = React.lazy(() => import("./pages/my-profile/my-profile"));
const Error = React.lazy(() => import("./pages/error/error-root"));
const Tip = React.lazy(() => import("./pages/tip/tip-root"));
const Documents = React.lazy(() => import("./pages/documents/documents-root"));
const Clock = React.lazy(() => import("./pages/clock/clock-root"));
const Feedback = React.lazy(() => import("./pages/feedback/feedback"));
const PeriodOverview = React.lazy(() => import("./pages/period-overview/period-overview-root"));
const Colleagues = React.lazy(() => import("./pages/colleagues/colleagues-root"));
const ColleaguesSystemSelector = React.lazy(() => import("./pages/colleagues/colleagues-system-selector"));

const AppRoutes = () => {
	const { systems, permissions } = useUserContext();
	const tipPermission = systems.some((s) => hasPermissionOnSystem(permissions, s.name, "portal.views.tip"));
	const webclockPermission = systems.some((s) =>
		hasPermissionOnSystem(permissions, s.name, "portal.clock.webclock"),
	);
	return (
		<Routes>
			<Route
				path={MyPagesRoutes.News}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<Home />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>

			<Route
				path={MyPagesRoutes.Schedule}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<Schedule />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			<Route
				path={MyPagesRoutes.TimeReport}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<TimeReport />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			<Route
				path={MyPagesRoutes.Salary}
				element={
					// <React.Suspense fallback={<LoadingScreen />}>
					//     <Salary />
					// </React.Suspense>
					<SalaryRoot />
				}
				errorElement={<Error />}
			/>
			<Route path={MyPagesRoutes.Menu} element={<NavRoot />} errorElement={<Error />} />
			<Route
				path={MyPagesRoutes.Messages}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<Messages />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			<Route
				path={MyPagesRoutes.Profile}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<MyProfile />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			{tipPermission && (
				<Route
					path={MyPagesRoutes.Tip}
					element={
						<React.Suspense fallback={<LoadingScreen />}>
							<Tip />
						</React.Suspense>
					}
					errorElement={<Error />}
				/>
			)}
			<Route
				path={MyPagesRoutes.Documents}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<Documents />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			<Route
				path={MyPagesRoutes.PeriodOverview}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<PeriodOverview />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			<Route
				path={MyPagesRoutes.Feedback}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<Feedback />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			{webclockPermission && (
				<Route
					path={MyPagesRoutes.Clock}
					element={
						<React.Suspense fallback={<LoadingScreen />}>
							<Clock />
						</React.Suspense>
					}
					errorElement={<Error />}
				/>
			)}
			<Route
				path={MyPagesRoutes.Colleagues}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<ColleaguesSystemSelector />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			<Route
				path={`${MyPagesRoutes.Colleagues}/:selectedSystem`}
				element={
					<React.Suspense fallback={<LoadingScreen />}>
						<Colleagues />
					</React.Suspense>
				}
				errorElement={<Error />}
			/>
			<Route path="*" element={<Navigate to="/schedule" replace />} />
			<Route path="auth/callback" element={<AuthRoot />} />
		</Routes>
	);
};

export default AppRoutes;
